import * as React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

/** A wa.me link takes the number as digits only, country code included. */
export const whatsappLink = (phone: string) => `https://wa.me/${phone.replace(/\D/g, '')}`;

/**
 * Green WhatsApp button that opens a chat with this number in WhatsApp (app or web).
 * Renders nothing without a number. Sits inside clickable rows, so its click stays its own.
 */
export const WhatsAppButton: React.FC<{ phone?: string | null; name?: string | null; size?: number }> = ({ phone, name, size = 28 }) => {
    if (!phone || !phone.replace(/\D/g, '')) return null;
    const label = `WhatsApp ${name || phone}`;
    return (
        <Tooltip title={label}>
            <IconButton
                component="a" href={whatsappLink(phone)} target="_blank" rel="noopener noreferrer"
                aria-label={label}
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
                sx={{ width: size, height: size, flexShrink: 0, bgcolor: '#25D366', color: '#fff', '&:hover': { bgcolor: '#1DA851' } }}
            >
                <WhatsAppIcon sx={{ fontSize: Math.round(size * 0.57) }} />
            </IconButton>
        </Tooltip>
    );
};
